var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"field-range-wrapper"}},[_c('base-input',_vm._g(_vm._b({attrs:{"type":"range"}},'base-input',_vm.componentProps,false),_vm.$listeners)),_c('span',{attrs:{"className":"range-view"}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }